var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/RedeemCard/RedeemCard.scss";
import GenericDetails from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import EmandateInfoPage from "@frameworks/shared-library/components/TransactionJourney/MutualFund/Mandate/EmandateInfoPage";
import TxnSuccess from "@frameworks/shared-library/assets/images/SalesJourney/txn-success.svg";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/CommonTocComponent/TxnConfirmationScreen.scss";
import { EMutualFundFlow } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFund";
var TxnConfirmationScreen = function (_a) {
    var backBtnOnClick = _a.backBtnOnClick, purchaseFormData = _a.purchaseFormData, txnType = _a.txnType, isModify = _a.isModify, orderStatus = _a.orderStatus;
    var rmEmail = "rm@nuvama.com";
    var _b = __read(useState([]), 2), genericDetailsProps = _b[0], setGenericDetailsProps = _b[1];
    var getGenericDetailsAccordionData = function () {
        switch (txnType) {
            case EMutualFundFlow.REDEEM:
                return [
                    {
                        label: "Redeem Amount",
                        value: (React.createElement("label", { className: "d-flex gap-1" },
                            React.createElement("span", { className: "RobotoM_15_500" },
                                "Approx. \u20B9", purchaseFormData === null || purchaseFormData === void 0 ? void 0 :
                                purchaseFormData.amount),
                            React.createElement("span", { className: "RobotoM_13_400 mt_2" },
                                "(units: ", purchaseFormData === null || purchaseFormData === void 0 ? void 0 :
                                purchaseFormData.quantity,
                                ")"))),
                    },
                ];
            case EMutualFundFlow.SWP:
                return [
                    {
                        label: "SWP Amount",
                        value: (React.createElement("label", { className: "d-flex gap-1" },
                            React.createElement("span", { className: "RobotoM_15_500" },
                                "Approx. \u20B9", purchaseFormData === null || purchaseFormData === void 0 ? void 0 :
                                purchaseFormData.amount),
                            React.createElement("span", { className: "RobotoM_13_400 mt_2" },
                                "(units: ", purchaseFormData === null || purchaseFormData === void 0 ? void 0 :
                                purchaseFormData.quantity,
                                ")"))),
                    },
                    {
                        label: "Withdrawal Date",
                        value: "".concat(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.sipDate),
                    },
                    {
                        label: "Number of Withdrawals",
                        value: "".concat(purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.installmentCount),
                    },
                ];
            case EMutualFundFlow.STP:
            case EMutualFundFlow.SWITCH:
                return [
                    {
                        label: "".concat(txnType === EMutualFundFlow.STP ? "STP" : "Switch", " Amount"),
                        value: (React.createElement("label", { className: "d-flex gap-1" },
                            React.createElement("span", { className: "RobotoM_15_500" },
                                "Approx. \u20B9", purchaseFormData === null || purchaseFormData === void 0 ? void 0 :
                                purchaseFormData.amount),
                            React.createElement("span", { className: "RobotoM_13_400 mt_2" },
                                "(units: ", purchaseFormData === null || purchaseFormData === void 0 ? void 0 :
                                purchaseFormData.unit,
                                ")"))),
                    },
                    {
                        label: "".concat(txnType === EMutualFundFlow.STP ? "Transfer" : "Switch", "  From"),
                        value: (React.createElement("div", { className: "d-flex flex-column" },
                            React.createElement("span", { className: "DMSans_13_400" }, purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.switchTransferFrom),
                            React.createElement("span", { className: "Roboto_12_300 txt-grey-shade1 " }, purchaseFormData === null || purchaseFormData === void 0 ? void 0 :
                                purchaseFormData.catName,
                                " | ", purchaseFormData === null || purchaseFormData === void 0 ? void 0 :
                                purchaseFormData.subCatName))),
                    },
                    {
                        label: "".concat(txnType === EMutualFundFlow.STP ? "Transfer" : "Switch", " To"),
                        value: (React.createElement("div", { className: "d-flex flex-column" },
                            React.createElement("span", { className: "Roboto_13_400" }, purchaseFormData === null || purchaseFormData === void 0 ? void 0 : purchaseFormData.switchTransferTo),
                            React.createElement("span", { className: "Roboto_12_300 txt-grey-shade1" }, purchaseFormData === null || purchaseFormData === void 0 ? void 0 :
                                purchaseFormData.switchToCatName,
                                " |", purchaseFormData === null || purchaseFormData === void 0 ? void 0 :
                                purchaseFormData.switchToSubCatName))),
                    },
                ];
        }
    };
    useEffect(function () {
        if (isModify) {
            setGenericDetailsProps(orderStatus === null || orderStatus === void 0 ? void 0 : orderStatus.genericDetails);
        }
        else
            setGenericDetailsProps(getGenericDetailsAccordionData());
    }, []);
    return (React.createElement("div", { className: "parent-order-info-container txn-confirmation-container" },
        React.createElement("main", { className: "emandate-container  d-flex flex-column align-items-center status-container pb-0" },
            React.createElement("p", { className: "DMSansNormal_20_400 align-self-start d-flex gap-1" },
                React.createElement("span", { onClick: backBtnOnClick },
                    React.createElement("i", { className: "edel-icon-left-shortArrow fs-14 hand_cursor" })),
                "Order Confirmation"),
            React.createElement(EmandateInfoPage, { iconSrc: TxnSuccess, title: "Confirm your ".concat(txnType === EMutualFundFlow.STP ? "Transfer" : txnType, " Order"), description: "" }),
            React.createElement("div", { className: "w-100 px-2 order-details-container" },
                React.createElement(GenericDetails, { details: genericDetailsProps }))),
        React.createElement("div", { className: "transaction-summary-container" },
            React.createElement("div", { role: "button", className: "editSection d-flex align-items-center justify-content-center m-0", "tab-index": 0, onClick: backBtnOnClick },
                React.createElement("i", { className: "edel-icon-edit" }),
                React.createElement("span", { className: "editText DMSans_13_400" }, "Edit Order Details")),
            txnType === EMutualFundFlow.STP ||
                txnType === EMutualFundFlow.SWITCH ||
                isModify ? null : (React.createElement("article", { className: "advisorContainer rounded p-2 d-flex flex-column" },
                React.createElement("p", { className: "advisorMessage DMSans_13_400 mb-0" }, "Consider switching to liquid or conservative funds instead of just withdrawing funds to your bank account."),
                React.createElement("p", { className: "advisorContact mb-0  DMSansNormal_12_400" },
                    React.createElement("span", { className: "advisorContactText" }, "or consult with "),
                    React.createElement("a", { href: "mailto:".concat(rmEmail), className: "advisorEmail" }, rmEmail)))))));
};
export default TxnConfirmationScreen;
